import * as THREE from 'three';

/**
 * CSS gradient stop colors used by `DeviationColorbar` and the LandXML
 * surface elevation/slope coloring. Keep both in sync.
 */
const STOPS: Record<string, string[]> = {
  SPECTRAL: ['#3288bd', '#66c2a5', '#abdda4', '#e6f598', '#ffffbf', '#fee08b', '#fdae61', '#f46d43', '#d53e4f'],
  RAINBOW: ['#00007f', '#0000ff', '#007fff', '#00ffff', '#7fff7f', '#ffff00', '#ff7f00', '#ff0000', '#7f0000'],
  VIRIDIS: ['#440154', '#3b528b', '#21918c', '#5ec962', '#fde725'],
  PLASMA: ['#0d0887', '#6a00a8', '#b12a90', '#e16462', '#fca636', '#f0f921'],
  INFERNO: ['#000004', '#420a68', '#932667', '#dd513a', '#fca50a', '#fcffa4'],
  GRAYSCALE: ['#000000', '#888888', '#ffffff'],
  YELLOW_GREEN: ['#ffffe5', '#f7fcb9', '#addd8e', '#41ab5d', '#006837'],
};

/** Sample a named colormap at t ∈ [0,1] and return a THREE.Color. */
export function sampleColormap(name: string, t: number, out: THREE.Color = new THREE.Color()): THREE.Color {
  const stops = STOPS[name] ?? STOPS.SPECTRAL;
  const x = Math.max(0, Math.min(1, t)) * (stops.length - 1);
  const i = Math.floor(x);
  const f = x - i;
  out.set(stops[i]);
  if (i < stops.length - 1) {
    const b = new THREE.Color(stops[i + 1]);
    out.lerp(b, f);
  }
  return out;
}
